import type { Context } from "react";
import { useContext } from "react";

export const useNonNullableContext = <V>(context: Context<V>) => {
    const value = useContext(context);

    if (!value) {
        throw new Error(`${context.displayName || "Context"}'s value is not provided`);
    }

    return value;
};
